import React from "react";

import Corpo from "../components/Corpo";

export default function TabTermoSim(props) {
  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div
          className="view-termo pane pane-game"
          style={{ maxHeight: "100%", overflow: "auto", marginTop: "38px" }}
        >
          <div
            className="scroll"
            style={{
              transform: "translate3d(0px, 0px, 0px) scale(1)",
            }}
          >
            <div className="text-container">
              <h2>Termos e Condições de Uso do Game</h2>
              <h3>Aceitação dos Termos e Condições de Uso</h3>
              <h4>
                Termo aceito em {localStorage.getItem("acceptedTermDate")}
              </h4>
              <p>
                O uso do ConheciGame (a partir de agora, denominado Game) oferecido 
                pela Universidade Corporativa Sebrae do Serviço Brasileiro de Apoio 
                às Micro e Pequenas Empresas (a partir de agora, denominado Sebrae) 
                está condicionado à aceitação e ao cumprimento dos Termos e Condições 
                de Uso descritos abaixo. Para fazer uso do Game é preciso: (i) ler 
                atentamente os termos descritos abaixo; (ii) concordar expressamente 
                com eles. Ao fazer uso do Game oferecido pelo Serviço Brasileiro de 
                Apoio às Micro e Pequenas Empresas (Sebrae), você (a partir de agora, 
                denominado Usuário) concorda que leu, entendeu e aceitou os termos, as 
                regras e as condições aqui dispostos. Os Termos e Condições de Uso 
                regulamentam a utilização do Game, que pertencem ao Sebrae, localizado 
                na SGAS Av. L2 Sul 604/605, Módulos 30/31, Asa Sul, Brasília/DF, 
                devidamente inscrito no CNPJ sob o nº 00.330.845/0001-45. O Game está 
                disponível para colaboradores do Sistema Sebrae com login de usuário 
                no SGUS e perfil na rede social Conexão Sebrae. O Sebrae se reserva o 
                direito de modificar, a qualquer momento, a apresentação, configuração
                e disponibilização do Game. O mesmo se aplica a estes Termos e 
                Condições de Uso, estabelecidos como condição fundamental para a 
                utilização do serviço.
              </p>
              <h3>Game</h3>
              <p>
                O Sebrae oferece ao Usuário um Game que tem o objetivo de complementar 
                os estudos e testar os conhecimentos em formato de quiz nos seguintes
                modos: (i) single player – em que o participante joga sozinho, on-line
                ou off-line, e (ii) multiplayer – em que o participante poderá jogar 
                com outros competidores que estejam on-line no momento.
              </p>
              <h3>Pontos virtuais</h3>
              <p>
                O Game poderá incluir a oportunidade de compra de pontos virtuais 
                (moeda in-game), que pode exigir que o Usuário execute tarefas a 
                serem determinadas para obter a moeda virtual. A moeda virtual 
                nunca pode ser trocada por dinheiro real, bens ou qualquer outro
                item de valor monetário. O Usuário entende que não tem nenhum 
                direito ou título que conquiste virtualmente no Game.
              </p>
              <h3>Gratuidade</h3>
              <p>
                O Game é oferecido ao Usuário de forma gratuita. Os valores referentes 
                à utilização dos serviços necessários ao acesso à internet, entre 
                outros, são de responsabilidade exclusiva do Usuário.
              </p>
              <h3>Utilização do Game</h3>
              <p>
                O Usuário reconhece que é responsável por quaisquer informações falsas 
                que possam ser prestadas durante a utilização do Game. O Usuário 
                isenta o Sebrae de qualquer responsabilidade quanto à veracidade dos
                dados fornecidos por ele durante o uso do Game.
              </p>
              <p>
                O usuário reconhece, ainda, que estes Termos e Condições de Uso do Game 
                oferecidos pelo Sebrae devem ser observados e fielmente cumpridos, sob 
                pena de cancelamento e bloqueio de utilização do Game e demais medidas 
                cabíveis, caso os mencionados Termos sejam violados ou descumpridos. A 
                utilização do Game não é obrigatória ao colaborador e/ou credenciado do 
                Sistema Sebrae, é uma atividade de entretenimento e aprendizado 
                complementar e não configura jornada de trabalho. A utilização do Game,
                bem como os pontos adquiridos no Game, não são critérios de nota e/ou 
                pontuação em qualquer programa da Universidade Corporativa. A utilização
                do Game implica na aceitação das Regras do Game.
              </p>
              <h3>Registro e dados pessoais</h3>
              <p>
                É dever do Usuário manter atualizados os dados pessoais fornecidos quando
                da utilização do Game. O Sebrae pode cancelar qualquer registro do Usuário, 
                a qualquer momento e sem prévio aviso, assim que tiver conhecimento, e a 
                seu exclusivo critério, se o Usuário descumprir, intencionalmente ou não,
                estes Termos e Condições de Uso ou violar leis e regulamentos federais,
                estaduais e/ou municipais, ou violar os princípios legais, a moral e os
                bons costumes.
              </p>
              <p>
                Os Usuários que tiverem seus registros cancelados não poderão mais 
                utilizar o Game.
              </p>
              <h3>Regras de conduta do Usuário</h3>
              <p>
                O Game pode fornecer canais de comunicação como fóruns, comunidades
                ou áreas de bate-papo projetado para permitir que o Usuário se 
                comunique com outros Usuários do Serviço. O Sebrae fica desobrigado 
                a monitorar esses canais de comunicação, mas poderá fazê-lo e se 
                reserva o direito de rever comentários postados nos canais de 
                comunicação e remover todos os materiais, a qualquer momento, 
                com ou sem aviso prévio por qualquer razão, a seu exclusivo critério.
                O Sebrae também poderá suspender qualquer acesso aos canais de 
                comunicação a qualquer momento, sem aviso prévio, por qualquer motivo.
                O Usuário reconhece que qualquer material ou comentário postados pelos 
                Usuários nos canais de comunicação não são endossados nem controlados 
                pelo Sebrae e estas comunicações não devem ser consideradas revistas 
                ou aprovadas pelo Sebrae. O Sebrae não será sob qualquer circunstância 
                responsável por qualquer atividade dentro de canais de comunicação. O 
                Usuário concorda que todas as contribuições nos canais de comunicação 
                são públicas, e, portanto, não tem nenhuma expectativa de privacidade 
                em relação ao seu uso. O Sebrae não se responsabiliza pelas informações 
                que o Usuário escolhe compartilhar nos Canais de Comunicação. O Usuário 
                deverá seguir o código de boa conduta do colaborador Sebrae.
              </p>
              <p>
                O Usuário se compromete a não utilizar o Game para a publicação,
                criação, armazenamento e/ou divulgação de:
              </p>
              <ol className="lists-ol">
                <li>
                  Conteúdo abusivo, como textos, fotos e/ou vídeos que tenham caráter 
                  difamatório, discriminatório, obsceno, ofensivo, ameaçador, abusivo, 
                  vexatório, prejudicial, que contenha expressões de ódio contra pessoas 
                  ou grupos, credo, cor, etnia, orientação sexual ou identidade e expressão 
                  de gênero ou que contenha pornografia infantil, pornografia explícita ou 
                  violenta, conteúdo que possa ser danoso a menores, que contenha insultos 
                  ou ameaças religiosas ou raciais, ou que incentive danos morais (incluindo 
                  os corporais) e patrimoniais, ou que possa violar qualquer direito de 
                  terceiro, notadamente os direitos humanos.
                </li>
                <li>
                  Banners publicitários e/ou qualquer tipo de comércio eletrônico que seja
                  considerado ilícito, assim entendidos os que sejam contrários à legislação
                  ou ofendam direitos de terceiros.
                </li>
                <li>
                  Qualquer tipo de material (textos, fotos e/ou vídeos) protegido por direitos
                  autorais, copyright ou que, por qualquer razão, violem direitos de terceiros.
                </li>
                <li>
                  Informações difamatórias e caluniosas ou que sejam contrárias à honra, à 
                  intimidade pessoal e familiar ou à imagem das pessoas (inclusive de pessoas 
                  jurídicas, entidades e organizações e ela equiparadas).
                </li>
                <li>
                  Material que incite à violência e à criminalidade, bem como à pirataria de 
                  produtos.
                </li>
                <li>
                  Conteúdo que provoque, por suas características (como extensões e formatos 
                  de arquivos) danos ao sistema do Sebrae.
                </li>
              </ol>
              <p>O Usuário concorda que, ao usar o Game, não irá:</p>
              <ul className="lists-ul">
                <li>violar qualquer um destes Termos e Condições de Uso;</li>
                <li>
                  praticar falsidade, assim entendidas a falsidade de informações (i.e: divulgação
                  proposital e voluntária de informações que o Usuário saiba ser falsa ou que 
                  sejam notoriamente falsas) e a falsidade ideológica;
                </li>
                <li>
                  publicar ou transmitir qualquer conteúdo abusivo ou ofensivo nos comentários;
                </li>
                <li>
                  replicar ou armazenar conteúdo abusivo nos servidores do Sebrae;
                </li>
                <li>
                  fazer qualquer coisa ou praticar qualquer ato contrário à boa-fé e aos usos e 
                  costumes das comunidades virtuais e que possam ofender qualquer direito de 
                  terceiros. Por violação aos usos e costumes de comunidades virtuais também 
                  deve ser entendido o uso excessivo de texto em letras maiúsculas, uso de 
                  críticas ofensivas (conhecidas como “flamming”), a inclusão desnecessária e 
                  imprudente de comunicações anteriores em qualquer publicação ou transmissão, 
                  bem como qualquer outro ato que esteja em desacordo com a etiqueta da Internet 
                  comumente aceita.
                </li>
                <li>cometer fraude;</li>
                <li>
                  violar ou infringir direitos de propriedade intelectual, direitos fiduciários 
                  ou contratuais, direitos de privacidade ou publicidade de outros;
                </li>
                <li>
                  propagar, distribuir ou transmitir códigos destrutivos, quer tenham ou não causado 
                  danos reais;
                </li>
                <li>
                  reunir dados pessoais ou comerciais, incluindo (mas não se limitando a) endereços 
                  de e-mail e/ou nomes de qualquer recurso da Internet, seja gerenciado por nós ou 
                  por terceiros, para fins comerciais, políticos, de benemerência ou outros, sem o 
                  consentimento dos proprietários desses dados;
                </li>
                <li>
                  reproduzir, replicar, copiar, alterar, modificar, criar obras derivativas a partir 
                  de, vender ou revender qualquer um dos serviços do Sebrae ou qualquer parte deles, 
                  incluindo websites e páginas web, ou as informações ou dados contidos nos serviços 
                  do Sebrae;
                </li>
                <li>
                  usar robôs, “spiders” ou qualquer outro dispositivo, automático ou manual, para 
                  monitorar ou copiar qualquer conteúdo do serviço do Sebrae;
                </li>
                <li>
                  transmitir conteúdo que não pertence ao Usuário ou que ele não tenha direito de 
                  publicar ou distribuir, seja sob lei ou contrato;
                </li>
                <li>
                  acessar o Game sem autorização, por meio de práticas de “hacking”, “password mining” 
                  ou qualquer outro meio fraudulento ou que represente violação a direito de terceiros;
                </li>
                <li>
                  realizar ou incentivar atividades ilegais, incluindo (mas não se limitando a) 
                  promover ou facilitar;
                </li>
                <li>
                  o acesso, uso ou venda de substâncias ou dispositivos perigosos;
                </li>
                <li>
                  deixar de cumprir com quaisquer leis, normas, regras, princípios e regulamentações 
                  aplicáveis;
                </li>
                <li>
                  ajudar qualquer terceiro a realizar qualquer uma das ações vedadas por estes Termos 
                  e Condições de Uso.
                </li>
              </ul>
              <h3>Direitos de Propriedade Intelectual</h3>
              <p>
                O Sebrae respeita os direitos de propriedade intelectual de terceiros e requer que os 
                Usuários façam o mesmo. Ao enviar qualquer conteúdo ou informação para o Game, incluindo 
                textos, tais como comentários, fóruns de discussão, comunidades, enquetes, testes, seção 
                de dúvidas, participação em concurso cultural, fotografias, ilustrações, vídeos, arquivos 
                de áudio e outros materiais, o Usuário declara autorizar de forma gratuita, não exclusiva, 
                perpétua, global e livre de royalty o uso do material pelo Sebrae e suas empresas 
                afiliadas e parceiras, por qualquer modalidade e suporte, para publicação, reprodução, 
                transmissão, retransmissão, distribuição, comunicação ao público, edição, adaptação e 
                outras transformações, tradução para qualquer idioma, inclusão em quaisquer outras obras, 
                representação, execução, uso por radiodifusão e outros meios de comunicação, mediante o 
                emprego de qualquer tecnologia, exposição, inclusão em base de dados e quaisquer outras 
                modalidades de utilização existentes ou que venham a ser inventadas no futuro, em quaisquer 
                suportes existentes ou que venham a ser inventados no futuro, autorizando também a criação 
                de obras derivadas e o sublicenciamento do material para uso em outras plataformas de 
                comunicação do Sebrae, sem limite de tempo e território.
              </p>
              <p>
                Qualquer eventual omissão não implicará limitação de uso do material pelo Sebrae. Se o 
                Usuário não concorda em autorizar o Sebrae a utilizar sua contribuição conforme acima, o 
                Usuário então não deverá submeter qualquer material para o Game. O Sebrae não está obrigado 
                a utilizar os materiais enviados pelo Usuário e está autorizado a editar os comentários 
                enviados pelo Usuário. O Usuário reconhece e declara que em qualquer contribuição submetida 
                para o Game, o material correspondente é de sua exclusiva criação, não constituindo violação 
                de direitos autorais, marcas, segredos, direitos de personalidade, incluindo honra, 
                intimidade, vida privada e a imagem das pessoas, direitos patrimoniais e quaisquer outros 
                direitos de terceiros e que possui poderes para autorizar o uso do material pelo Sebrae 
                conforme acima.
              </p>
              <p>
                Desde que citada a fonte (inclusive o nome do autor, quando possível e aplicável) e dentro 
                das condições e limites previstos em lei, notadamente a Lei de Direitos Autorais (Lei n.º 
                9.610/98), o Usuário não pode reproduzir, publicar, apresentar, alugar, oferecer ou expor 
                qualquer cópia de qualquer conteúdo pertencente ao Sebrae sem o consentimento do Sebrae ou, 
                no caso de conteúdo de autoria de terceiros, sem o consentimento do autor ou autora. O 
                Usuário se compromete a cumprir todas as leis nacionais e internacionais referentes aos 
                Direitos de Propriedade Intelectual.
              </p>
              <h3>Denúncia de abusos e violação</h3>
              <p>
                O Usuário se compromete a denunciar quaisquer abusos ou violação destes Termos e Condições 
                de Uso ou de quaisquer direitos de terceiros que observar e/ou for vítima quando da utilização 
                do Game. O Usuário deve utilizar o canal disponibilizado no Game para comunicação.
              </p>
              <p>
                Todo conteúdo que o Usuário publica utilizando qualquer fórum de discussão é uma informação 
                que, por sua natureza e característica, é pública, aberta e não confidencial. Ao revelar dados 
                pessoais, tais como seu nome e endereço de e-mail nos comentários, o Usuário aceita e compreende 
                que essa informação pode ser coletada e usada por outras pessoas para se comunicarem com ele, 
                sem que seja imputável qualquer responsabilidade ao Sebrae. Desta forma, o Sebrae recomenda que 
                o Usuário seja, portanto, cuidadoso ao decidir compartilhar qualquer dado pessoal em qualquer 
                website.
              </p>
              <h3>Responsabilidades</h3>
              <p>
                O Sebrae não se responsabiliza por quaisquer danos sofridos pelo Usuário ou terceiros que, de 
                qualquer modo, tenha origem ou dependência relacionada ao Game. O Sebrae se exime de quaisquer 
                responsabilidades sobre prejuízos resultantes de qualquer interrupção ou erro nos Games virtuais 
                do Sebrae, incluindo a impossibilidade de acessar o Game e/ou os websites relacionados a ele.
              </p>
              <h3>Privacidade de dados</h3>
              <p>
                O Sebrae não se responsabiliza por quaisquer danos que o Usuário possa sofrer, que tenham origem 
                na divulgação dos dados pessoais do Usuário ou de terceiros em materiais publicados em qualquer 
                website.
              </p>
              <p>
                O Sebrae preserva a privacidade dos dados dos Usuários, e se compromete a revelar os dados pessoais 
                do Usuário apenas devido a um dos seguintes motivos:
              </p>
              <ul className="lists-ul">
                <li>por lei;</li>
                <li>
                  por meio de uma ordem ou intimação de um órgão, autoridade ou tribunal com poderes para tanto 
                  e de jurisdição competente;
                </li>
                <li>
                  para garantir a segurança dos sistemas, resguardar direitos e prevenir responsabilidades do 
                  Sebrae.
                </li>
              </ul>
              <h3>Legislação aplicável</h3>
              <p>
                Estes Termos e Condições de Uso são governados e interpretados segundo as leis da República Federativa 
                do Brasil e todas as disputas, ações e outros assuntos relacionados serão determinados de acordo com 
                essa legislação.
              </p>
              <h3>Política de Privacidade</h3>
              <p>
                A política de privacidade tem como objetivo deixar claro o compromisso do Sebrae em garantir a proteção 
                dos dados solicitados. Para navegar em áreas restritas do Game e ter acesso a serviços exclusivos, o 
                usuário precisa ter acesso (login e senha) do SGUS. Não fornecemos suas informações pessoais para 
                terceiros sem a sua autorização e não divulgamos informações que possam identificar os usuários. 
                Somente dados genéricos e agregados, referentes à quantidade de pessoas que acessam áreas dos nossos 
                sites, podem ser divulgados. Utilizamos seu e-mail apenas para enviar newsletters ou para informar e 
                divulgar, desde que você nos dê autorização para isso. Essas regras sobre privacidade se aplicam apenas 
                ao ConheciGame. Elas não valem para os sites do Sistema Sebrae. Você deve se informar sobre a política 
                de cada um deles antes de fornecer qualquer tipo de informação.
              </p>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
